export var MainMenuIcon;
(function (MainMenuIcon) {
    MainMenuIcon["BellIcon"] = "BellIcon";
    MainMenuIcon["HomeIcon"] = "HomeIcon";
    MainMenuIcon["NewspaperIcon"] = "NewspaperIcon";
    MainMenuIcon["SearchIcon"] = "SearchIcon";
    MainMenuIcon["UserCircleIcon"] = "UserCircleIcon";
    MainMenuIcon["UserGroupIcon"] = "UserGroupIcon";
    MainMenuIcon["ViewGridIcon"] = "ViewGridIcon";
})(MainMenuIcon || (MainMenuIcon = {}));
export var MainMenuAction;
(function (MainMenuAction) {
    MainMenuAction["OPEN_SPACE"] = "OPEN_SPACE";
    MainMenuAction["OPEN_PROFILE"] = "OPEN_PROFILE";
    MainMenuAction["OPEN_LINK"] = "OPEN_LINK";
})(MainMenuAction || (MainMenuAction = {}));
//# sourceMappingURL=types.js.map